import { ReactNode } from "react";
import NewsType from "../models/news_type";
import styles from "./styles/news_tile.module.scss";

interface NewsTileProps {
  imagePath: string;
  text: string;
  date: string;
  newsType: NewsType;
  footer?: ReactNode;
}

export const NewsTile: React.FC<NewsTileProps> = ({ imagePath, text, footer, date, newsType }) => {
  const renderNewType = () => {
    switch (newsType) {
      case NewsType.Event:
        return <>Event</>;
      case NewsType.News:
        return <>News</>;
      case NewsType.Upcoming:
        return <>Upcoming</>;
      default:
        return <></>;
    }
  };

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.tileImage}>
          <div className={styles.image} style={{ backgroundImage: `url(${imagePath})` }}>
            <div className={styles.tileInfo}>
              <div className={styles.badge}>{date}</div>
              <div className={styles.badgeType}>{renderNewType()}</div>
            </div>
          </div>
        </div>
        <div className={styles.text}>
          {text}
          <br />
          {footer}
        </div>
      </div>
    </>
  );
};
